/**
 * Configuration for the synthetic "website URL" question that the DSE
 * privacy-policy questionnaire injects on the frontend. This question is not
 * part of the LegalOS questionnaire definition; it is spliced into the
 * rendered step stream so we can capture the user's website URL and kick off
 * the embedded CookieRadar scan that pre-fills later service-selection
 * questions.
 */

// Stable id for the synthetic URL step (used for navigation by step id).
export const WEBSITE_URL_STEP_ID = '__website_url_question__';

// The synthetic URL question is inserted *after* this many real steps.
// Position is clamped to the available number of steps.
export const URL_QUESTION_INSERT_AFTER = 5;
